import React from "react"
import { CircularProgress } from "@material-ui/core"
import { Container } from "./styles"

function Loading({ show }) {
  return (
    <Container show={show}>
      <CircularProgress size={60} />
    </Container>
  )
}

export default Loading
